import Box from '@mui/material/Box';
import type { ReactElement, ReactNode } from 'react';

export type OnboardingStepContentProps = {
    children: ReactNode;
    maxWidth?: number;
};

export function OnboardingStepContent({ children, maxWidth = 600 }: OnboardingStepContentProps): ReactElement {
    return (
        <Box
            sx={{
                flex: 1,
                width: '100%',
                maxWidth,
                mx: 'auto',
                px: 3,
                py: { xs: 4, md: 8 },
            }}>
            {children}
        </Box>
    );
}
